"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerBriefingDocument = exports.InstructionTypeEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const opportunity_1 = require("./opportunity");
const job_type_enum_1 = require("./job-type-enum");
const data_ui_1 = require("../data-ui");
const contact_profile_enum_1 = require("./contact-profile-enum");
const layouts_1 = require("../data-ui/layouts");
var InstructionTypeEnum;
(function (InstructionTypeEnum) {
    InstructionTypeEnum["PARTNER_BRIEFING"] = "Partner Briefing";
    InstructionTypeEnum["ADDITIONAL_INSTRUCTIONS"] = "Additional Documents & Instructions";
})(InstructionTypeEnum = exports.InstructionTypeEnum || (exports.InstructionTypeEnum = {}));
let PartnerBriefingDocument = class PartnerBriefingDocument {
};
__decorate([
    data_ui_1.DataUi.Override({ generated: true, label: 'ID' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], PartnerBriefingDocument.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'File' }),
    data_ui_1.DataUi.S3File({
        name: (i) => `partner-briefing-documents/${i === null || i === void 0 ? void 0 : i.opportunity.id}/${i === null || i === void 0 ? void 0 : i.generatedId}`,
        fullUrl: true,
        arrayMode: 'append',
    }),
    (0, typeorm_1.Column)({
        type: 'varchar',
        nullable: false,
    }),
    __metadata("design:type", String)
], PartnerBriefingDocument.prototype, "fileUrl", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)(() => opportunity_1.Opportunity, (opportunity) => opportunity.partnerBriefingDocuments, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'opportunity_sfid', referencedColumnName: 'id' }),
    __metadata("design:type", opportunity_1.Opportunity)
], PartnerBriefingDocument.prototype, "opportunity", void 0);
__decorate([
    data_ui_1.DataUi.EnumValues(job_type_enum_1.JobTypeEnum),
    data_ui_1.DataUi.Override({ label: 'Job Type' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: job_type_enum_1.JobTypeEnum,
        nullable: false,
        default: job_type_enum_1.JobTypeEnum.PRECHECK,
    }),
    __metadata("design:type", String)
], PartnerBriefingDocument.prototype, "jobType", void 0);
__decorate([
    data_ui_1.DataUi.EnumValues(InstructionTypeEnum),
    data_ui_1.DataUi.Override({ label: 'Instruction Type' }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: InstructionTypeEnum,
        nullable: false,
        default: InstructionTypeEnum.PARTNER_BRIEFING,
    }),
    __metadata("design:type", String)
], PartnerBriefingDocument.prototype, "instructionType", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], PartnerBriefingDocument.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], PartnerBriefingDocument.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.DeleteDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], PartnerBriefingDocument.prototype, "deletedAt", void 0);
PartnerBriefingDocument = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'PartnerBriefingDocument',
        nameProperties: ['id'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('partner_briefing_documents', { schema: 'public' }),
    (0, typeorm_1.Unique)(['fileUrl', 'opportunity', 'jobType'])
], PartnerBriefingDocument);
exports.PartnerBriefingDocument = PartnerBriefingDocument;
//# sourceMappingURL=partner-briefing-documents.js.map